import React, { useRef, useEffect } from 'react';
import { Employee } from '../../../../types';
import EmployeeItem from '../EmployeeItem/EmployeeItem';
import style from './EmployeeList.module.css';

interface EmployeeListProps {
  /** §FB81: GUID власника компанії (адмін-конвенція) для PATCH вебперемикача особи. */
  companyId: number | null;
  companyWebLiaisonEnabled: boolean;
  /** §FB170: хто зараз на чергуванні в кабінеті викликів. */
  onDutyIds?: Set<string>;
  employees: Employee[];
  hasMore: boolean;
  isFetching: boolean;
  onLoadMore: () => void;
  onDeleteClick: (employee: Employee) => void;
}

const EmployeeList: React.FC<EmployeeListProps> = ({
  companyId,
  companyWebLiaisonEnabled,
  onDutyIds,
  employees,
  hasMore,
  isFetching,
  onLoadMore,
  onDeleteClick,
}) => {
  const employeeContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      const element = employeeContainerRef.current;
      if (
        element &&
        element.scrollTop + element.clientHeight >=
          element.scrollHeight - 500 &&
        hasMore &&
        !isFetching
      ) {
        onLoadMore();
      }
    };

    const element = employeeContainerRef.current;
    element?.addEventListener('scroll', handleScroll);
    return () => element?.removeEventListener('scroll', handleScroll);
  }, [hasMore, isFetching, onLoadMore]);

  // §FB39c: якщо завантажена порція не переповнила контейнер (вкладка тепер на
  // всю висоту екрана), скрол-подія не настане ніколи — доливаємо наступні
  // сторінки, доки не з'явиться що скролити або дані не скінчаться. Ключуємо на
  // identity масиву: рівно один виклик на порцію даних, сторінки не губляться
  // (onLoadMore робить setPageIndex(prev => prev + 1)).
  useEffect(() => {
    const element = employeeContainerRef.current;
    if (
      element &&
      employees.length > 0 &&
      hasMore &&
      !isFetching &&
      element.scrollHeight <= element.clientHeight + 4
    ) {
      onLoadMore();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employees, hasMore, isFetching]);

  return (
    <div className={style.employeeContainer} ref={employeeContainerRef}>
      {employees.length === 0 ? (
        <p className={style.noEmployees}>Співробітників не знайдено</p>
      ) : (
        employees.map((employee, index) => (
          <EmployeeItem
            key={employee.id}
            companyId={companyId}
            companyWebLiaisonEnabled={companyWebLiaisonEnabled}
            onDuty={!!onDutyIds?.has(employee.id)}
            employee={employee}
            index={index}
            onDeleteClick={onDeleteClick}
          />
        ))
      )}
    </div>
  );
};

export default EmployeeList;
